import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    createUrl: String,
    placeholder: String,
    allowCreate: Boolean
  }

  connect() {
    // Determine if creation should be allowed
    // If allowCreate is explicitly false, disable creation
    // If allowCreate is true or not set, and createUrl is provided, use createTag
    // If allowCreate is true or not set, and no createUrl, allow basic creation
    let createOption = false
    if (this.hasAllowCreateValue) {
      if (this.allowCreateValue && this.hasCreateUrlValue) {
        createOption = this.createTag.bind(this)
      } else if (this.allowCreateValue) {
        createOption = true
      }
    } else {
      // Default behavior: allow creation if createUrl is provided, otherwise allow basic creation
      createOption = this.hasCreateUrlValue ? this.createTag.bind(this) : true
    }

    const options = {
      plugins: ['remove_button'],
      persist: false,
      create: createOption,
      placeholder: this.placeholderValue || 'Select tags...',
      closeAfterSelect: false,
      onItemAdd: function() {
        this.setTextboxValue('')
        this.refreshOptions()
      }
    }

    this.tomSelect = new TomSelect(this.element, options)
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }

  async createTag(input, callback) {
    if (!this.hasCreateUrlValue) {
      callback({ value: input, text: input })
      return
    }

    try {
      const response = await fetch(this.createUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ name: input })
      })

      if (response.ok) {
        const tag = await response.json()
        callback({ value: tag.id, text: tag.name })
      } else {
        callback()
      }
    } catch (error) {
      console.error('Error creating tag:', error)
      callback()
    }
  }
}
